import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  /** ... */
  collapsed: boolean;
}

/** `MobileMenuButton` component emits. */
export type Emits = (event: 'click', value: MouseEvent) => void;


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileMenuButton',
  props: {
    collapsed: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any) {

/**
 * `MobileMenuButton` component properties.
 */




return { __sfc: true, }
}

})